<template>
  <div class="accounts">
    <template v-if="this.total < 0">
      <div class="alert alert-info" role="alert" style="margin-top: 30px">
        Searching...
      </div>
    </template>
    <template v-else-if="this.total > 0">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">{{ totalComputed }} emails in blacklist</h1>
      </div>
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Email</th>
            <th>Reason</th>
            <th>Expires</th>
            <th class="text-right">Unlock</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="account in items" v-bind:key="account.email">
            <td>{{ account.email }}</td>
            <td>{{ account.code }} - {{ account.message }}</td>
            <td>
              <template v-if="account.expires">{{
                account.expires | relative
              }}</template>
              <template v-else>No</template>
            </td>
            <td class="text-right">
              <a
                href="javascript:;"
                title="Unban this user"
                class="btn btn-danger"
                v-on:click="unban(account.id)"
                >Unblock</a
              >
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-else>
      <template v-if="$route.query.qs">
        <div class="alert alert-warning" role="alert" style="margin-top: 30px">
          No emails currently in blacklist.
        </div>
      </template>
      <template v-else>
        <div class="alert alert-primary" role="alert" style="margin-top: 30px">
          Use the search bar at the top to search for emails.
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { formatHttpError } from "../utils/errors";

export default {
  data() {
    return {
      total: -1,
      items: [],
    };
  },
  created() {
    this.search(true);
    this.autoBlockFromQuery();
  },
  computed: {
    totalComputed() {
      if (this.total < 1000) return this.total;
      else return "1000+";
    },
  },
  methods: {
    search(redirect) {
      console.log(this.$route);
      // Only include email parameter if there's a search query
      const requestData = {};
      if (this.$route.query.qs && this.$route.query.qs.trim()) {
        requestData.email = this.$route.query.qs.trim();
      }

      this.$http.post("refuseds", requestData).then(
        (response) => {
          this.total = response.body.total;
          this.items = response.body.items;
        },
        (response) => {
          if (response.status === 401) return;
          alert(formatHttpError(response));
        },
      );
    },
    unban(id) {
      this.$http.delete("refuseds/" + id).then(
        () => {
          // Remove this line
          const idx = this.items.findIndex((x) => x.id === id);
          this.items.splice(idx, 1);
        },
        (response) => {
          alert(formatHttpError(response));
        },
      );
    },
    // Lets Slack abuse alerts link straight to a one-click destination block, e.g.
    // /refuseds/?block=true&destination=collector@gmail.com&reason=Mail-harvesting%20collector
    autoBlockFromQuery() {
      const { block, destination, reason } = this.$route.query;
      if (block !== "true" || !destination) return;
      this.$http.post("refuseds/block", { email: destination, reason }).then(
        () => {
          alert(
            `destination ${destination} blocked — forwarding to it is now refused for all accounts.`,
          );
          this.search(true);
        },
        (response) => {
          alert(formatHttpError(response));
        },
      );
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.search(true);
  },
};
</script>
